module.exports = __webpack_public_path__ + "static/media/CyclonX-RC-4400.6ce3305c.png";